import { render, staticRenderFns } from "./TagSelector.vue?vue&type=template&id=16a392ce&scoped=true"
import script from "./TagSelector.vue?vue&type=script&lang=js"
export * from "./TagSelector.vue?vue&type=script&lang=js"
import style0 from "./TagSelector.vue?vue&type=style&index=0&id=16a392ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a392ce",
  null
  
)

export default component.exports